import api from '@/helpers/api';

export const getSignedUrl = async (
	awsKey: string
): Promise<{
	signedUrl: string;
	key: string;
	expireIn: number;
	time: number;
} | null> => {
	try {
		const response = await api.request<{
			signedUrl: string;
			key: string;
			expireIn: number;
		}>({ url: `/file/url/${awsKey}`, method: 'get' });
		return { ...response.data, time: Date.now() };
	} catch (error) {
		console.error('Error getting signed url:', error);
		return null;
	}
};
